<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>

    <template #content>
      <article class="blog-content" lang="de">
        <section class="intro">
          <p>
            Wenn Sie Ihr Travvir-Konto löschen möchten, beachten Sie bitte, dass
            diese Funktion derzeit nur in der Android-App verfügbar ist.
            Befolgen Sie die nachstehenden Schritte, um Ihr Konto dauerhaft zu
            löschen.
          </p>
        </section>

        <section>
          <h2>Schritt-für-Schritt-Anleitung</h2>
          <ol>
            <li>Öffnen Sie die Travvir-App auf Ihrem Android-Gerät.</li>
            <li>
              Tippen Sie auf das Hamburger-Menü-Symbol (drei horizontale Linien)
              in der oberen linken Ecke, um die Navigationsleiste zu öffnen.
            </li>
          </ol>

          <figure class="content-image">
            <NuxtImg
              :src="cdnUrl + '/static/images/delete_account_1.jpg'"
              alt="Navigationsleiste mit der Option Konto löschen"
            />
            <figcaption>
              Abbildung 1: Navigationsleiste mit der Option „Konto löschen"
            </figcaption>
          </figure>

          <ol start="3">
            <li>
              Scrollen Sie nach unten und tippen Sie im Menü auf „Konto
              löschen".
            </li>
            <li>
              Ein Bestätigungsdialog wird angezeigt. Tippen Sie auf
              <strong>„Löschen"</strong>, um zu bestätigen und Ihr Konto
              dauerhaft zu löschen.
            </li>
          </ol>

          <figure class="content-image">
            <NuxtImg
              :src="cdnUrl + '/static/images/delete_account_2.jpg'"
              alt="Bestätigungsdialog für die Kontolöschung"
            />
            <figcaption>
              Abbildung 2: Bestätigungsdialog zum Löschen des Kontos
            </figcaption>
          </figure>
        </section>

        <section>
          <div class="warning-box">
            <h4>⚠️ Wichtig</h4>
            <p>
              Sobald Sie die Kontolöschung einleiten, werden Ihr Konto und alle
              zugehörigen Daten nach 14 Tagen gelöscht. Wenn Sie Ihre Meinung
              ändern, können Sie sich innerhalb dieses Zeitraums erneut
              anmelden, um den Löschvorgang abzubrechen.
            </p>
          </div>
        </section>
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";

const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;

const postData = blogPostsData.find((post) => post.slug === "konto-loeschen");

useBlogSeo({
  title: "Travvir-Konto löschen [2026]: Schritt-für-Schritt | Travvir",
  description:
    "So löschen Sie Ihr Travvir-Konto vollständig. Anleitung zur Datenlöschung und Kontoschließung Schritt für Schritt erklärt.",
  slug: "konto-loeschen",
  image: postData?.image,
  postData,
  lang: "de",
});

</script>
